import { StyleColorSchemeType } from '../../../styles/enums';
import { HintTooltipProperty, TooltipProperty } from '../enum';
import TooltipProps from '@/ui-kit/components/tooltip/mixins/TooltipProps';

const HintTooltipProps = {
  props: {
    [HintTooltipProperty.Header]: {
      default: '',
      type: String,
    },
    [HintTooltipProperty.Message]: {
      default: '',
      type: String,
    },
    [HintTooltipProperty.ColorScheme]: {
      default: StyleColorSchemeType.White,
      type: String,
    },
    [HintTooltipProperty.DisplayType]: TooltipProps.props[TooltipProperty.DisplayType],
  },
};

export default HintTooltipProps;
